export function filterByTags(objects, tags) {
  const filteredObjects = [];
  for (const obj of objects) {
    const objTags = obj.tags || [];
    if (objTags.some(tag => tags.includes(tag)) &&
        objTags.filter(tag => tags.includes(tag)).length === 1) {
      filteredObjects.push(obj);
    }
  }
  return filteredObjects;
}

export function filterByProperty(array, property, value) {
    const filteredArray = [];
  
    for (const object of array) {
      if (object[property] === value) {
        filteredArray.push(object);
      }
    }
  
    return filteredArray;
  }

export function groupByProperty(array, property) {
    const groups = {};
    for (const object of array) {
      const group = object[property];
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(object);
    }
    return groups;
  }
  

export function trimSentence(str, num) {
    return str.trim(" ").slice(0, num);
}

export function generateRandomNumber(num) {
  // Get a random number between 0 and 1.
  const randomNumber = Math.random();

  // Multiply the random number by 5 and add 1.
  // This will give us a random number between 1 and 5.
  const result = Math.floor(randomNumber * num) + 1;

  return result;
}

export function pickRandomStringWithoutRepeating(array) {
  // Create a copy of the array so we don't modify the original.
  const arrayCopy = array.slice();

  // Generate a random index between 0 and the length of the array copy.
  const randomIndex = Math.floor(Math.random() * arrayCopy.length);

  // Get the random string at the random index.
  const randomString = arrayCopy[randomIndex];

  // Remove the random string from the array copy so it can't be picked again.
  arrayCopy.splice(randomIndex, 1);

  // Return the random string.
  return randomString;
}

export const shuffle = (array) => { 
  for (let i = array.length - 1; i > 0; i--) { 
    const j = Math.floor(Math.random() * (i + 1)); 
    [array[i], array[j]] = [array[j], array[i]]; 
  } 
  return array; 
}; 

export const addOrRemoveObjectFromArray = (array, object) => {
  const index = array.findIndex(element => element === object);
  if (index === -1) {
    // Object does not exist in array, so add it.
    array.push(object);
  } else {
    // Object exists in array, so remove it.
    array.splice(index, 1);
  }

  return array
};

export const getUniqueTags = (serviceProviders) => {
  // Create a new set to store the unique tags.
  const uniqueTags = new Set();

  // Iterate over the service providers and add their tags to the set.
  serviceProviders.forEach((serviceProvider) => {
    const tags = serviceProvider.tags || [];
    tags.forEach((tag) => {
      uniqueTags.add(tag);
    });
  });

  // Convert the set to an array and return it.
  return Array.from(uniqueTags);
}